import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      context.toast({
        title: 'Not authenticated',
        description: 'It seems you are not connected / session has expired',
        variant: 'destructive',
        duration: 5000,
      });
      return redirect({ to: '/login' });
    }
  },
});
